import { useEffect, useState } from 'react';

let open = false;
const listeners = new Set<() => void>();

export function setShopAnnouncementOpen(next: boolean) {
  if (open === next) return;
  open = next;
  listeners.forEach((listener) => listener());
}

/** True while a shop announcement dialog is on screen, so the bonus popup waits. */
export function useShopAnnouncementOpen() {
  const [value, setValue] = useState(open);
  useEffect(() => {
    const listener = () => setValue(open);
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);
  return value;
}
